import { render } from "./AppNavLink.vue?vue&type=template&id=5c92c685"
import script from "./AppNavLink.vue?vue&type=script&lang=js"
export * from "./AppNavLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__